import { del, get, getBlob, patch, post } from '../client';

export const indentsApi = {
  list: (params) => get('/indents', { params }),
  exportExcel: (params) => getBlob('/indents/export', { params }),
  pendingCount: () => get('/indents/pending-count'),
  getById: (id) => get(`/indents/${id}`),
  create: (body) => post('/indents', body),
  recommend: (requestId, lineId, body) =>
    post(`/indents/${requestId}/lines/${lineId}/recommend`, body),
  removeRecommendation: (requestId, lineId, recId) =>
    post(`/indents/${requestId}/lines/${lineId}/recommendations/${recId}/remove`),
  assign: (requestId, lineId, body) =>
    post(`/indents/${requestId}/lines/${lineId}/assign`, body),
  updateAssignment: (requestId, lineId, body) =>
    patch(`/indents/${requestId}/lines/${lineId}/assignment`, body),
  release: (requestId, lineId, body) =>
    post(`/indents/${requestId}/lines/${lineId}/release`, body),
  cancel: (id) => post(`/indents/${id}/cancel`),
  remove: (id) => del(`/indents/${id}`),
};
